import { AnimatedSection } from "./AnimatedSection";
import { ArrowRight } from "lucide-react";
import { analytics } from "@/lib/analytics";

const buyerPoints = [
  "Make better sourcing decisions",
  "Reduce pricing uncertainty",
  "Move faster on supply opportunities",
  "Access structured, verified supply",
];

export function BuyerSection({ openModal }) {
  return (
    <section id="buyer-section" className="py-24 md:py-32 bg-[#050A07]" data-testid="buyer-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <AnimatedSection>
            <p className="text-[#22C55E] text-sm font-medium tracking-widest uppercase mb-4">
              For Buyers
            </p>
            <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
              For Buyers
            </h2>
            <div className="mt-8 space-y-4">
              {buyerPoints.map((point, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-1.5 h-1.5 bg-[#22C55E] flex-shrink-0" />
                  <p className="text-[#A1B2A8] text-base">{point}</p>
                </div>
              ))}
            </div>
            <button
              onClick={() => { analytics.ctaClicked("Apply as Buyer", "buyer_section"); openModal("buyer"); }}
              className="mt-10 bg-[#16A34A] text-white hover:bg-[#15803D] transition-all px-8 py-4 font-medium font-['Outfit'] inline-flex items-center gap-2 group"
              data-testid="buyer-apply-btn"
            >
              Apply as Buyer
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
          </AnimatedSection>

          <AnimatedSection delay={0.15}>
            <div className="bg-[#09120D] border border-[#1A2E22] p-10 lg:p-14">
              <div className="space-y-6">
                <div className="flex items-center justify-between border-b border-[#1A2E22] pb-4">
                  <span className="text-[#A1B2A8] text-sm">Pricing Visibility</span>
                  <span className="text-[#22C55E] font-['Outfit'] font-semibold">Structured</span>
                </div>
                <div className="flex items-center justify-between border-b border-[#1A2E22] pb-4">
                  <span className="text-[#A1B2A8] text-sm">Supply Reliability</span>
                  <span className="text-[#22C55E] font-['Outfit'] font-semibold">Verified</span>
                </div>
                <div className="flex items-center justify-between border-b border-[#1A2E22] pb-4">
                  <span className="text-[#A1B2A8] text-sm">Deal Execution</span>
                  <span className="text-[#22C55E] font-['Outfit'] font-semibold">Faster</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-[#A1B2A8] text-sm">Participant Network</span>
                  <span className="text-[#22C55E] font-['Outfit'] font-semibold">Controlled</span>
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
